import PropTypes from "prop-types"

const ColumnChartShape = {
  categories: PropTypes.arrayOf(PropTypes.string).isRequired,
  bars: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string,
    data: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.number, PropTypes.object])).isRequired,
  })).isRequired,
}

export default ColumnChartShape



// WEBPACK FOOTER //
// ./src/state/shapes/ColumnChartShape.js